// Pre-bundled shadcn/ui files to avoid download delays during bootstrap
// These are the essential files needed for shadcn/ui to work

export const SHADCN_COMPONENTS_JSON = `{
  "$schema": "https://ui.shadcn.com/schema.json",
  "style": "default",
  "rsc": false,
  "tsx": true,
  "tailwind": {
    "config": "",
    "css": "src/index.css",
    "baseColor": "neutral",
    "cssVariables": true,
    "prefix": ""
  },
  "aliases": {
    "components": "@/components",
    "utils": "@/lib/utils",
    "ui": "@/components/ui",
    "lib": "@/lib",
    "hooks": "@/hooks"
  }
}`;

// Plain CSS for src/index.css — NO @import "tailwindcss" or @theme directives.
// Tailwind v4 is loaded via CDN <script> in index.html (not PostCSS).
// This file only contains CSS variables and keyframes that work without any processing.
export const SHADCN_TAILWIND_DIRECTIVES = `@keyframes accordion-down {
  from { height: 0; }
  to { height: var(--radix-accordion-content-height); }
}

@keyframes accordion-up {
  from { height: var(--radix-accordion-content-height); }
  to { height: 0; }
}

:root {
  --background: 220 15% 8%;
  --foreground: 220 10% 97%;
  --surface: 220 15% 11%;
  --surface-foreground: 220 10% 95%;
  --sidebar: 220 15% 10%;
  --sidebar-foreground: 220 10% 80%;
  --card: 220 15% 13%;
  --card-foreground: 220 10% 95%;
  --popup: 220 15% 15%;
  --popup-foreground: 220 10% 98%;
  --primary: 25 90% 55%;
  --primary-foreground: 25 10% 10%;
  --secondary: 220 10% 25%;
  --secondary-foreground: 220 10% 90%;
  --accent: 145 70% 45%;
  --accent-foreground: 145 10% 5%;
  --muted: 220 10% 18%;
  --muted-foreground: 220 10% 65%;
  --error: 0 80% 60%;
  --error-foreground: 0 10% 98%;
  --destructive: 0 80% 60%;
  --destructive-foreground: 0 10% 98%;
  --warning: 45 90% 50%;
  --warning-foreground: 45 10% 10%;
  --success: 145 70% 45%;
  --success-foreground: 145 10% 5%;
  --info: 200 80% 50%;
  --info-foreground: 200 10% 95%;
  --border: 220 10% 22%;
  --input: 220 10% 22%;
  --ring: 25 90% 55%;
  --radius: 12px;

  /* Untitled UI Gray */
  --ut-gray-25: #FCFCFD; --ut-gray-50: #F9FAFB; --ut-gray-100: #F2F4F7;
  --ut-gray-200: #EAECF0; --ut-gray-300: #D0D5DD; --ut-gray-400: #98A2B3;
  --ut-gray-500: #667085; --ut-gray-600: #475467; --ut-gray-700: #344054;
  --ut-gray-800: #182230; --ut-gray-900: #101828; --ut-gray-950: #0C111D;
  /* Untitled UI Brand */
  --ut-brand-25: #FCFAFF; --ut-brand-50: #F9F5FF; --ut-brand-100: #F4EBFF;
  --ut-brand-200: #E9D7FE; --ut-brand-300: #D6BBFB; --ut-brand-400: #B692F6;
  --ut-brand-500: #9E77ED; --ut-brand-600: #7F56D9; --ut-brand-700: #6941C6;
  --ut-brand-800: #53389E; --ut-brand-900: #42307D; --ut-brand-950: #2C1C5F;
  /* Untitled UI Error */
  --ut-error-25: #FFFBFA; --ut-error-50: #FEF3F2; --ut-error-100: #FEE4E2;
  --ut-error-200: #FECDCA; --ut-error-300: #FDA29B; --ut-error-400: #F97066;
  --ut-error-500: #F04438; --ut-error-600: #D92D20; --ut-error-700: #B42318;
  --ut-error-800: #912018; --ut-error-900: #7A271A; --ut-error-950: #55160C;
  /* Untitled UI Warning */
  --ut-warning-25: #FFFCF5; --ut-warning-50: #FFFAEB; --ut-warning-100: #FEF0C7;
  --ut-warning-200: #FEDF89; --ut-warning-300: #FEC84B; --ut-warning-400: #FDB022;
  --ut-warning-500: #F79009; --ut-warning-600: #DC6803; --ut-warning-700: #B54708;
  --ut-warning-800: #93370D; --ut-warning-900: #7A2E0E; --ut-warning-950: #4E1D09;
  /* Untitled UI Success */
  --ut-success-25: #F6FEF9; --ut-success-50: #ECFDF3; --ut-success-100: #D1FADF;
  --ut-success-200: #A6F4C5; --ut-success-300: #6CE9A6; --ut-success-400: #32D583;
  --ut-success-500: #12B76A; --ut-success-600: #039855; --ut-success-700: #027A48;
  --ut-success-800: #05603A; --ut-success-900: #054F31; --ut-success-950: #053321;
}

.dark {
  --background: 220 15% 8%;
  --foreground: 220 10% 97%;
  --surface: 220 15% 11%;
  --surface-foreground: 220 10% 95%;
  --sidebar: 220 15% 10%;
  --sidebar-foreground: 220 10% 80%;
  --card: 220 15% 13%;
  --card-foreground: 220 10% 95%;
  --popup: 220 15% 15%;
  --popup-foreground: 220 10% 98%;
  --primary: 25 90% 55%;
  --primary-foreground: 25 10% 10%;
  --secondary: 220 10% 25%;
  --secondary-foreground: 220 10% 90%;
  --accent: 145 70% 45%;
  --accent-foreground: 145 10% 5%;
  --muted: 220 10% 18%;
  --muted-foreground: 220 10% 65%;
  --error: 0 80% 60%;
  --error-foreground: 0 10% 98%;
  --destructive: 0 80% 60%;
  --destructive-foreground: 0 10% 98%;
  --warning: 45 90% 50%;
  --warning-foreground: 45 10% 10%;
  --success: 145 70% 45%;
  --success-foreground: 145 10% 5%;
  --info: 200 80% 50%;
  --info-foreground: 200 10% 95%;
  --border: 220 10% 22%;
  --input: 220 10% 22%;
  --ring: 25 90% 55%;
}

.light {
  --background: 220 20% 97%;
  --foreground: 220 15% 15%;
  --surface: 220 15% 94%;
  --surface-foreground: 220 15% 10%;
  --sidebar: 220 15% 96%;
  --sidebar-foreground: 220 10% 25%;
  --card: 0 0% 100%;
  --card-foreground: 220 15% 10%;
  --popup: 0 0% 100%;
  --popup-foreground: 220 15% 10%;
  --primary: 25 95% 53%;
  --primary-foreground: 0 0% 100%;
  --secondary: 220 10% 85%;
  --secondary-foreground: 220 15% 20%;
  --accent: 145 70% 40%;
  --accent-foreground: 0 0% 100%;
  --muted: 220 10% 90%;
  --muted-foreground: 220 15% 35%;
  --error: 0 80% 55%;
  --error-foreground: 0 0% 100%;
  --destructive: 0 80% 55%;
  --destructive-foreground: 0 0% 100%;
  --warning: 38 92% 50%;
  --warning-foreground: 220 15% 10%;
  --success: 145 70% 40%;
  --success-foreground: 0 0% 100%;
  --info: 200 80% 45%;
  --info-foreground: 0 0% 100%;
  --border: 220 10% 85%;
  --input: 220 10% 85%;
  --ring: 25 95% 53%;
}

@layer base {
  *, *::before, *::after {
    border-color: hsl(var(--border));
  }
  body {
    background-color: hsl(var(--background));
    color: hsl(var(--foreground));
    font-family: var(--font-sans, 'Inter', system-ui, sans-serif);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading, 'Space Grotesk', system-ui, sans-serif);
    line-height: 1.2;
  }
  code, pre, kbd {
    font-family: var(--font-mono, 'JetBrains Mono', monospace);
  }
}`;

// Standard CSS that esbuild can process — :root variables, keyframes, base reset.
// No @import "tailwindcss", @theme, @custom-variant, @apply, or @layer.
export const SHADCN_CSS_VARIABLES = `@keyframes accordion-down {
  from { height: 0; }
  to { height: var(--radix-accordion-content-height); }
}

@keyframes accordion-up {
  from { height: var(--radix-accordion-content-height); }
  to { height: 0; }
}

/* ============================================================================
 * Design Tokens — Default: Dark Theme (matches tasking.tech color system)
 * ============================================================================ */
:root {
  --background: hsl(220 15% 8%);
  --foreground: hsl(220 10% 97%);
  --surface: hsl(220 15% 11%);
  --surface-foreground: hsl(220 10% 95%);
  --sidebar: hsl(220 15% 10%);
  --sidebar-foreground: hsl(220 10% 80%);
  --card: hsl(220 15% 13%);
  --card-foreground: hsl(220 10% 95%);
  --popup: hsl(220 15% 15%);
  --popup-foreground: hsl(220 10% 98%);
  --primary: hsl(25 90% 55%);
  --primary-foreground: hsl(25 10% 10%);
  --secondary: hsl(220 10% 25%);
  --secondary-foreground: hsl(220 10% 90%);
  --accent: hsl(145 70% 45%);
  --accent-foreground: hsl(145 10% 5%);
  --muted: hsl(220 10% 18%);
  --muted-foreground: hsl(220 10% 65%);
  --error: hsl(0 80% 60%);
  --error-foreground: hsl(0 10% 98%);
  --warning: hsl(45 90% 50%);
  --warning-foreground: hsl(45 10% 10%);
  --success: hsl(145 70% 45%);
  --success-foreground: hsl(145 10% 5%);
  --info: hsl(200 80% 50%);
  --info-foreground: hsl(200 10% 95%);
  --border: hsl(220 10% 22%);
  --radius: 12px;
  --radius-sm: 8px;
  --radius-md: 14px;
  --radius-lg: 16px;
  --radius-xl: 20px;
  --shadow: 0 1px 3px 0 rgb(0 0 0/0.3),0 1px 2px -1px rgb(0 0 0/0.2);
  --shadow-md: 0 4px 8px -2px rgb(0 0 0/0.4),0 2px 4px -2px rgb(0 0 0/0.3);
  --shadow-lg: 0 12px 24px -4px rgb(0 0 0/0.5),0 4px 8px -4px rgb(0 0 0/0.4);
  --shadow-glow-primary: 0 0 20px rgba(249,115,22,0.15),0 0 40px rgba(249,115,22,0.05);
  --shadow-glow-accent: 0 0 20px rgba(34,197,94,0.12),0 0 40px rgba(34,197,94,0.04);

  /* === Untitled UI Design Tokens === */
  /* Gray */
  --ut-gray-25: #FCFCFD; --ut-gray-50: #F9FAFB; --ut-gray-100: #F2F4F7;
  --ut-gray-200: #EAECF0; --ut-gray-300: #D0D5DD; --ut-gray-400: #98A2B3;
  --ut-gray-500: #667085; --ut-gray-600: #475467; --ut-gray-700: #344054;
  --ut-gray-800: #182230; --ut-gray-900: #101828; --ut-gray-950: #0C111D;
  /* Brand (Purple) */
  --ut-brand-25: #FCFAFF; --ut-brand-50: #F9F5FF; --ut-brand-100: #F4EBFF;
  --ut-brand-200: #E9D7FE; --ut-brand-300: #D6BBFB; --ut-brand-400: #B692F6;
  --ut-brand-500: #9E77ED; --ut-brand-600: #7F56D9; --ut-brand-700: #6941C6;
  --ut-brand-800: #53389E; --ut-brand-900: #42307D; --ut-brand-950: #2C1C5F;
  /* Error (Red) */
  --ut-error-25: #FFFBFA; --ut-error-50: #FEF3F2; --ut-error-100: #FEE4E2;
  --ut-error-200: #FECDCA; --ut-error-300: #FDA29B; --ut-error-400: #F97066;
  --ut-error-500: #F04438; --ut-error-600: #D92D20; --ut-error-700: #B42318;
  --ut-error-800: #912018; --ut-error-900: #7A271A; --ut-error-950: #55160C;
  /* Warning (Orange) */
  --ut-warning-25: #FFFCF5; --ut-warning-50: #FFFAEB; --ut-warning-100: #FEF0C7;
  --ut-warning-200: #FEDF89; --ut-warning-300: #FEC84B; --ut-warning-400: #FDB022;
  --ut-warning-500: #F79009; --ut-warning-600: #DC6803; --ut-warning-700: #B54708;
  --ut-warning-800: #93370D; --ut-warning-900: #7A2E0E; --ut-warning-950: #4E1D09;
  /* Success (Green) */
  --ut-success-25: #F6FEF9; --ut-success-50: #ECFDF3; --ut-success-100: #D1FADF;
  --ut-success-200: #A6F4C5; --ut-success-300: #6CE9A6; --ut-success-400: #32D583;
  --ut-success-500: #12B76A; --ut-success-600: #039855; --ut-success-700: #027A48;
  --ut-success-800: #05603A; --ut-success-900: #054F31; --ut-success-950: #053321;
  /* Untitled UI Shadows */
  --ut-shadow-xs: 0px 1px 2px rgba(16, 24, 40, 0.05);
  --ut-shadow-sm: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  --ut-shadow-md: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  --ut-shadow-lg: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  --ut-shadow-xl: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
  --ut-shadow-2xl: 0px 24px 48px -12px rgba(16, 24, 40, 0.18);
  --ut-shadow-3xl: 0px 32px 64px -12px rgba(16, 24, 40, 0.14);
  /* Untitled UI Radius */
  --ut-radius-none: 0px; --ut-radius-xxs: 2px; --ut-radius-xs: 4px;
  --ut-radius-sm: 6px; --ut-radius-md: 8px; --ut-radius-lg: 10px;
  --ut-radius-xl: 12px; --ut-radius-2xl: 16px; --ut-radius-3xl: 20px;
  --ut-radius-4xl: 24px; --ut-radius-full: 9999px;
  /* Untitled UI Typography Scale */
  --ut-display-2xl: 4.5rem; --ut-display-xl: 3.75rem; --ut-display-lg: 3rem;
  --ut-display-md: 2.25rem; --ut-display-sm: 1.875rem; --ut-display-xs: 1.5rem;
  --ut-text-xl: 1.25rem; --ut-text-lg: 1.125rem; --ut-text-md: 1rem;
  --ut-text-sm: 0.875rem; --ut-text-xs: 0.75rem;
  /* Untitled UI Spacing (4px base) */
  --ut-spacing-0: 0px; --ut-spacing-0-5: 2px; --ut-spacing-1: 4px;
  --ut-spacing-1-5: 6px; --ut-spacing-2: 8px; --ut-spacing-2-5: 10px;
  --ut-spacing-3: 12px; --ut-spacing-4: 16px; --ut-spacing-5: 20px;
  --ut-spacing-6: 24px; --ut-spacing-8: 32px; --ut-spacing-10: 40px;
  --ut-spacing-12: 48px; --ut-spacing-16: 64px; --ut-spacing-20: 80px;
  --ut-spacing-24: 96px;
}

/* Dark class — explicit toggle (identical to :root default) */
.dark {
  --background: hsl(220 15% 8%);
  --foreground: hsl(220 10% 97%);
  --surface: hsl(220 15% 11%);
  --surface-foreground: hsl(220 10% 95%);
  --sidebar: hsl(220 15% 10%);
  --sidebar-foreground: hsl(220 10% 80%);
  --card: hsl(220 15% 13%);
  --card-foreground: hsl(220 10% 95%);
  --popup: hsl(220 15% 15%);
  --popup-foreground: hsl(220 10% 98%);
  --primary: hsl(25 90% 55%);
  --primary-foreground: hsl(25 10% 10%);
  --secondary: hsl(220 10% 25%);
  --secondary-foreground: hsl(220 10% 90%);
  --accent: hsl(145 70% 45%);
  --accent-foreground: hsl(145 10% 5%);
  --muted: hsl(220 10% 18%);
  --muted-foreground: hsl(220 10% 65%);
  --error: hsl(0 80% 60%);
  --error-foreground: hsl(0 10% 98%);
  --warning: hsl(45 90% 50%);
  --warning-foreground: hsl(45 10% 10%);
  --success: hsl(145 70% 45%);
  --success-foreground: hsl(145 10% 5%);
  --info: hsl(200 80% 50%);
  --info-foreground: hsl(200 10% 95%);
  --border: hsl(220 10% 22%);
}

/* Light theme */
.light {
  --background: hsl(220 20% 97%);
  --foreground: hsl(220 15% 15%);
  --surface: hsl(220 15% 94%);
  --surface-foreground: hsl(220 15% 10%);
  --sidebar: hsl(220 15% 96%);
  --sidebar-foreground: hsl(220 10% 25%);
  --card: hsl(0 0% 100%);
  --card-foreground: hsl(220 15% 10%);
  --popup: hsl(0 0% 100%);
  --popup-foreground: hsl(220 15% 10%);
  --primary: hsl(25 95% 53%);
  --primary-foreground: hsl(0 0% 100%);
  --secondary: hsl(220 10% 85%);
  --secondary-foreground: hsl(220 15% 20%);
  --accent: hsl(145 70% 40%);
  --accent-foreground: hsl(0 0% 100%);
  --muted: hsl(220 10% 90%);
  --muted-foreground: hsl(220 15% 35%);
  --error: hsl(0 80% 55%);
  --error-foreground: hsl(0 0% 100%);
  --warning: hsl(38 92% 50%);
  --warning-foreground: hsl(220 15% 10%);
  --success: hsl(145 70% 40%);
  --success-foreground: hsl(0 0% 100%);
  --info: hsl(200 80% 45%);
  --info-foreground: hsl(0 0% 100%);
  --border: hsl(220 10% 85%);
  --shadow: 0 1px 2px 0 rgb(0 0 0/0.1);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0/0.1),0 2px 4px -2px rgb(0 0 0/0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0/0.15),0 4px 6px -4px rgb(0 0 0/0.1);
  --shadow-glow-primary: 0 0 20px rgba(249,115,22,0.1),0 0 40px rgba(249,115,22,0.03);
  --shadow-glow-accent: 0 0 20px rgba(34,197,94,0.08),0 0 40px rgba(34,197,94,0.02);
}

/* Base reset — plain CSS (no @apply, no @layer — esbuild-safe) */
html {
  color-scheme: dark;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
*, *::before, *::after {
  box-sizing: border-box;
  border-color: var(--border);
}
body {
  background-color: var(--background);
  color: var(--foreground);
  font-family: var(--font-sans, 'Inter', system-ui, sans-serif);
  line-height: 1.6;
}
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading, 'Space Grotesk', system-ui, sans-serif);
  line-height: 1.2;
}
code, pre, kbd {
  font-family: var(--font-mono, 'JetBrains Mono', monospace);
}`;

export const SHADCN_UTILS = `import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}`;

// Core UI Components - Button
// NOTE: No forwardRef — preview environment doesn't need ref forwarding,
// and forwardRef patterns are the #1 source of bracket mismatch errors.
// NOTE: Slot is inlined instead of imported from @radix-ui/react-slot to avoid
// the React 19 infinite re-render loop bug (composeRefs creates new ref identity
// each render → React 19 detach/attach loop). Simple cloneElement-based Slot
// handles the common asChild use case (e.g. <Button asChild><Link>...</Link></Button>).
export const SHADCN_BUTTON = `import * as React from "react";
import { cn } from "@/lib/utils";

type ButtonVariant = "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
type ButtonSize = "default" | "sm" | "lg" | "icon";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const variantClasses: Record<ButtonVariant, string> = {
  default: "bg-primary text-primary-foreground hover:bg-primary/90",
  destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
  outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
  secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
  ghost: "hover:bg-accent hover:text-accent-foreground",
  link: "text-primary underline-offset-4 hover:underline",
};

const sizeClasses: Record<ButtonSize, string> = {
  default: "h-10 px-4 py-2",
  sm: "h-9 rounded-md px-3",
  lg: "h-11 rounded-md px-8",
  icon: "h-10 w-10",
};

export function Button({ className, variant = "default", size = "default", type = "button", ...props }: ButtonProps) {
  return React.createElement("button", {
    type,
    className: cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      variantClasses[variant],
      sizeClasses[size],
      className
    ),
    ...props,
  });
}

export default Button;`;

// Card Component — plain functions, no forwardRef (preview doesn't need ref forwarding)
export const SHADCN_CARD = `import * as React from "react";
import { cn } from "@/lib/utils";

type DivProps = React.HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...props }: DivProps) {
  return React.createElement("div", { className: cn("rounded-lg border bg-card text-card-foreground shadow-sm", className), ...props });
}

export function CardHeader({ className, ...props }: DivProps) {
  return React.createElement("div", { className: cn("flex flex-col space-y-1.5 p-6", className), ...props });
}

export function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return React.createElement("h3", { className: cn("text-2xl font-semibold leading-none tracking-tight", className), ...props });
}

export function CardDescription({ className, ...props }: DivProps) {
  return React.createElement("p", { className: cn("text-sm text-muted-foreground", className), ...props });
}

export function CardContent({ className, ...props }: DivProps) {
  return React.createElement("div", { className: cn("p-6 pt-0", className), ...props });
}

export function CardFooter({ className, ...props }: DivProps) {
  return React.createElement("div", { className: cn("flex items-center p-6 pt-0", className), ...props });
}

export default Card;`;

// Input Component — plain function, no forwardRef
export const SHADCN_INPUT = `import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

function Input({ className, type, ...props }: InputProps) {
  return React.createElement("input", {
    type,
    className: cn(
      "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      className
    ),
    ...props,
  });
}

export { Input };
export default Input;`;

// Label Component — plain function, no forwardRef
export const SHADCN_LABEL = `import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);

function Label({ className, ...props }: React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>) {
  return React.createElement(LabelPrimitive.Root, { className: cn(labelVariants(), className), ...props });
}

export { Label };`;

// Badge Component
export const SHADCN_BADGE = `import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return React.createElement("div", { className: cn(badgeVariants({ variant }), className), ...props });
}

export { Badge, badgeVariants };
export default Badge;`;

// Theme Provider for dark/light mode
export const SHADCN_THEME_PROVIDER = `import * as React from "react";
const ThemeProviderContext = React.createContext(undefined);

function resolveTheme(theme) {
  if (theme === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return theme;
}

export function ThemeProvider({
  children,
  defaultTheme = "system",
  storageKey = "ui-theme",
}) {
  const [theme, setTheme] = React.useState(() => {
    const saved = localStorage.getItem(storageKey);
    return saved || defaultTheme;
  });

  React.useEffect(() => {
    const root = window.document.documentElement;
    const applied = resolveTheme(theme);
    root.classList.remove("light", "dark");
    root.classList.add(applied);
    root.style.colorScheme = applied;
  }, [theme]);

  const value = React.useMemo(
    () => ({
      theme,
      setTheme: (nextTheme) => {
        localStorage.setItem(storageKey, nextTheme);
        setTheme(nextTheme);
      },
    }),
    [theme, storageKey]
  );

  return React.createElement(ThemeProviderContext.Provider, { value: value }, children);
}

export function useTheme() {
  const context = React.useContext(ThemeProviderContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}

export default ThemeProvider;`;

// Theme Toggle Component
export const SHADCN_THEME_TOGGLE = `import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/theme-provider";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const h = React.createElement;

  return h(Button, { variant: "ghost", size: "icon", onClick: () => setTheme(theme === "light" ? "dark" : "light"), className: "h-9 w-9" },
    h(Sun, { className: "h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" }),
    h(Moon, { className: "absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" }),
    h("span", { className: "sr-only" }, "Toggle theme")
  );
}`;

// Sidebar fallback component
export const SHADCN_SIDEBAR = `import * as React from "react";
import { cn } from "@/lib/utils";

interface SidebarProps extends React.HTMLAttributes<HTMLElement> {
  title?: string;
}

export default function Sidebar({
  className,
  title = "Navigation",
  children,
  ...props
}: SidebarProps) {
  const h = React.createElement;
  return h("aside", { className: cn("w-64 border-r border-border bg-sidebar text-sidebar-foreground p-4", className), ...props },
    h("h2", { className: "mb-4 text-sm font-semibold uppercase tracking-wide text-muted-foreground" }, title),
    h("nav", { className: "space-y-2" }, children)
  );
}`;

// Responsive Container Component — plain function, no forwardRef
export const SHADCN_CONTAINER = `import * as React from "react";
import { cn } from "@/lib/utils";

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg" | "xl" | "full";
}

function Container({ className, size = "lg", ...props }: ContainerProps) {
  const sizeClasses = {
    sm: "max-w-screen-sm",
    md: "max-w-screen-md",
    lg: "max-w-screen-lg",
    xl: "max-w-screen-xl",
    full: "max-w-full",
  };

  return React.createElement("div", {
    className: cn("mx-auto w-full px-4 sm:px-6 lg:px-8", sizeClasses[size], className),
    ...props,
  });
}

export { Container };`;

// Toast stub — prevents "Failed to resolve import" when AI generates toast references
export const SHADCN_TOAST = `import * as React from "react";

interface ToastProps {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
}

export function ToastContainer() {
  const [toasts, setToasts] = React.useState<(ToastProps & { id: number })[]>([]);

  React.useEffect(() => {
    const handler = (e: CustomEvent<ToastProps>) => {
      const id = Date.now();
      setToasts((prev) => [...prev, { ...e.detail, id }]);
      setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), 4000);
    };
    window.addEventListener("toast" as any, handler as any);
    return () => window.removeEventListener("toast" as any, handler as any);
  }, []);

  if (toasts.length === 0) return null;
  const h = React.createElement;

  return h("div", { style: { position: "fixed", bottom: 16, right: 16, zIndex: 9999, display: "flex", flexDirection: "column", gap: 8 } },
    ...toasts.map((t) =>
      h("div", {
        key: t.id,
        style: {
          padding: "12px 16px",
          borderRadius: 8,
          background: t.variant === "destructive" ? "hsl(0 84.2% 60.2%)" : "hsl(var(--primary, 0 0% 9%))",
          color: "hsl(var(--primary-foreground, 0 0% 98%))",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          minWidth: 200,
          animation: "slideIn 0.2s ease-out",
        }
      },
        t.title ? h("div", { style: { fontWeight: 600, marginBottom: 2 } }, t.title) : null,
        t.description ? h("div", { style: { fontSize: 14, opacity: 0.9 } }, t.description) : null
      )
    )
  );
}

export function useToast() {
  const toast = (props: ToastProps) => {
    window.dispatchEvent(new CustomEvent("toast", { detail: props }));
  };
  return { toast, toasts: [] as (ToastProps & { id: number })[], dismiss: () => {} };
}

export function ToastProvider({ children }: { children: React.ReactNode }) {
  return React.createElement(React.Fragment, null, children, React.createElement(ToastContainer));
}

export { ToastContainer as Toaster };
export default ToastContainer;`;

// use-toast hook stub
export const SHADCN_USE_TOAST = `type ToastProps = {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
};

export function useToast() {
  const toast = (props: ToastProps) => {
    window.dispatchEvent(new CustomEvent("toast", { detail: props }));
  };

  return { toast, toasts: [] as ToastProps[], dismiss: () => {} };
}

export { useToast as default };`;

// Separator Component — plain function, no forwardRef
export const SHADCN_SEPARATOR = `import * as React from "react";
import { cn } from "@/lib/utils";

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
  decorative?: boolean;
}

function Separator({ className, orientation = "horizontal", decorative = true, ...props }: SeparatorProps) {
  return React.createElement("div", {
    role: decorative ? "none" : "separator",
    "aria-orientation": orientation === "horizontal" ? undefined : orientation,
    className: cn("shrink-0 bg-border", orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", className),
    ...props,
  });
}

export { Separator };`;

// Textarea Component — plain function, no forwardRef
export const SHADCN_TEXTAREA = `import * as React from "react";
import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

function Textarea({ className, ...props }: TextareaProps) {
  return React.createElement("textarea", {
    className: cn("flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className),
    ...props,
  });
}

export { Textarea };`;

// Skeleton Component
export const SHADCN_SKELETON = `import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return React.createElement("div", {
    className: cn("animate-pulse rounded-md bg-muted", className),
    ...props,
  });
}

export { Skeleton };`;

// Avatar Component — plain functions, no forwardRef
export const SHADCN_AVATAR = `import * as React from "react";
import { cn } from "@/lib/utils";

function Avatar({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return React.createElement("span", { className: cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className), ...props });
}

function AvatarImage({ className, src, alt, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [hasError, setHasError] = React.useState(false);
  if (!src || hasError) return null;
  return React.createElement("img", { src, alt, className: cn("aspect-square h-full w-full object-cover", className), onError: () => setHasError(true), ...props });
}

function AvatarFallback({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return React.createElement("span", { className: cn("flex h-full w-full items-center justify-center rounded-full bg-muted", className), ...props });
}

export { Avatar, AvatarImage, AvatarFallback };`;

// Dialog Component — wraps @radix-ui/react-dialog with Tailwind styling
export const SHADCN_DIALOG = `import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;
export const DialogPortal = DialogPrimitive.Portal;

export function DialogOverlay({ className, ...props }: React.ComponentProps<typeof DialogPrimitive.Overlay>) {
  return React.createElement(DialogPrimitive.Overlay, {
    className: cn("fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
    ...props,
  });
}

export function DialogContent({ className, children, ...props }: React.ComponentProps<typeof DialogPrimitive.Content>) {
  const h = React.createElement;
  return h(DialogPortal, null,
    h(DialogOverlay),
    h(DialogPrimitive.Content, {
      className: cn("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg", className),
      ...props,
    },
      children,
      h(DialogPrimitive.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground" },
        h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
          h("path", { d: "M18 6 6 18" }),
          h("path", { d: "m6 6 12 12" })
        ),
        h("span", { className: "sr-only" }, "Close")
      )
    )
  );
}

export function DialogHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return React.createElement("div", { className: cn("flex flex-col space-y-1.5 text-center sm:text-left", className), ...props });
}

export function DialogFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return React.createElement("div", { className: cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className), ...props });
}

export function DialogTitle({ className, ...props }: React.ComponentProps<typeof DialogPrimitive.Title>) {
  return React.createElement(DialogPrimitive.Title, { className: cn("text-lg font-semibold leading-none tracking-tight", className), ...props });
}

export function DialogDescription({ className, ...props }: React.ComponentProps<typeof DialogPrimitive.Description>) {
  return React.createElement(DialogPrimitive.Description, { className: cn("text-sm text-muted-foreground", className), ...props });
}`;

// Checkbox Component — plain function, no forwardRef
export const SHADCN_CHECKBOX = `import * as React from "react";
import { cn } from "@/lib/utils";

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

function Checkbox({ className, checked, onCheckedChange, disabled, id, ...props }: CheckboxProps) {
  const [isChecked, setIsChecked] = React.useState(checked ?? false);

  React.useEffect(() => {
    if (checked !== undefined) setIsChecked(checked);
  }, [checked]);

  const handleClick = () => {
    if (disabled) return;
    const next = !isChecked;
    setIsChecked(next);
    onCheckedChange?.(next);
  };

  const h = React.createElement;
  return h("button", {
    type: "button",
    role: "checkbox",
    id,
    "aria-checked": isChecked,
    disabled,
    onClick: handleClick,
    className: cn(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      isChecked && "bg-primary text-primary-foreground",
      className
    ),
    ...(props as any),
  },
    isChecked ? h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", className: "h-3.5 w-3.5" },
      h("polyline", { points: "20 6 9 17 4 12" })
    ) : null
  );
}

export { Checkbox };`;

// Tabs Component — simple tab UI using React.createElement, no radix-ui dependency
export const SHADCN_TABS = `import * as React from "react";
import { cn } from "@/lib/utils";

interface TabsProps extends React.HTMLAttributes<HTMLDivElement> {
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
}

const TabsContext = React.createContext<{
  value: string;
  onValueChange: (value: string) => void;
}>({ value: "", onValueChange: () => {} });

export function Tabs({ defaultValue = "", value, onValueChange, className, children, ...props }: TabsProps) {
  const [internalValue, setInternalValue] = React.useState(defaultValue);
  const currentValue = value !== undefined ? value : internalValue;
  const handleChange = React.useCallback((v: string) => {
    if (value === undefined) setInternalValue(v);
    onValueChange?.(v);
  }, [value, onValueChange]);

  return React.createElement(TabsContext.Provider, { value: { value: currentValue, onValueChange: handleChange } },
    React.createElement("div", { className: cn("w-full", className), ...props }, children)
  );
}

export function TabsList({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return React.createElement("div", {
    role: "tablist",
    className: cn("inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground", className),
    ...props
  }, children);
}

export function TabsTrigger({ className, value, children, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement> & { value: string }) {
  const ctx = React.useContext(TabsContext);
  const isActive = ctx.value === value;
  return React.createElement("button", {
    type: "button",
    role: "tab",
    "aria-selected": isActive,
    onClick: () => ctx.onValueChange(value),
    className: cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      isActive && "bg-background text-foreground shadow-sm",
      className
    ),
    ...props
  }, children);
}

export function TabsContent({ className, value, children, ...props }: React.HTMLAttributes<HTMLDivElement> & { value: string }) {
  const ctx = React.useContext(TabsContext);
  if (ctx.value !== value) return null;
  return React.createElement("div", {
    role: "tabpanel",
    className: cn("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className),
    ...props
  }, children);
}

export default Tabs;`;

// Header Component — simple header with title and subtitle
export const SHADCN_HEADER = `import * as React from "react";
import { cn } from "@/lib/utils";

export interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  title?: string;
  subtitle?: string;
}

export function Header({ title = "App", subtitle, className, children, ...props }: HeaderProps) {
  return React.createElement("header", {
    className: cn("w-full border-b border-border bg-background/95 px-4 py-3", className),
    ...props
  },
    React.createElement("div", { className: "mx-auto flex w-full max-w-6xl items-center justify-between gap-3" },
      React.createElement("div", { className: "min-w-0" },
        React.createElement("h1", { className: "truncate text-base font-semibold" }, title),
        subtitle ? React.createElement("p", { className: "truncate text-xs text-muted-foreground" }, subtitle) : null
      ),
      children
    )
  );
}

export default Header;`;

// Helper to get all bundled files as a map
export function getShadcnBundledFiles(): Record<string, string> {
  return {
    'components.json': SHADCN_COMPONENTS_JSON,
    'src/lib/utils.ts': SHADCN_UTILS,
    'src/components/ui/button.tsx': SHADCN_BUTTON,
    'src/components/ui/card.tsx': SHADCN_CARD,
    'src/components/ui/input.tsx': SHADCN_INPUT,
    'src/components/ui/label.tsx': SHADCN_LABEL,
    'src/components/ui/badge.tsx': SHADCN_BADGE,
    'src/components/ui/container.tsx': SHADCN_CONTAINER,
    'src/components/ui/separator.tsx': SHADCN_SEPARATOR,
    'src/components/ui/textarea.tsx': SHADCN_TEXTAREA,
    'src/components/ui/skeleton.tsx': SHADCN_SKELETON,
    'src/components/ui/avatar.tsx': SHADCN_AVATAR,
    'src/components/ui/checkbox.tsx': SHADCN_CHECKBOX,
    'src/components/ui/dialog.tsx': SHADCN_DIALOG,
    'src/components/ui/tabs.tsx': SHADCN_TABS,
    'src/components/Header.tsx': SHADCN_HEADER,
    'src/components/theme-provider.tsx': SHADCN_THEME_PROVIDER,
    'src/components/theme-toggle.tsx': SHADCN_THEME_TOGGLE,
    'src/components/Sidebar.tsx': SHADCN_SIDEBAR,
    'src/components/Toast.tsx': SHADCN_TOAST,
    'src/components/use-toast.ts': SHADCN_USE_TOAST,
    'src/hooks/use-toast.ts': SHADCN_USE_TOAST,
  };
}

// Get esbuild-safe CSS (standard :root vars, keyframes, base reset)
export function getShadcnCssVariables(): string {
  return SHADCN_CSS_VARIABLES;
}

// Get Tailwind v4 directives for <style type="text/tailwindcss"> in the preview HTML
export function getShadcnTailwindDirectives(): string {
  return SHADCN_TAILWIND_DIRECTIVES;
}
